import "jquery-ui/ui/widgets/autocomplete";
import "jquery-ui/ui/widgets/button";
import "jquery-ui/ui/widgets/slider";
import "jquery-ui/ui/widgets/checkboxradio";
import "jquery-ui/ui/widgets/selectmenu";
import DataHandler from "../data/DataHandler";
import MapHandler from "../map/MapHandler";
import { ChartDataBySection, ChartDataByYear, UserResource } from "../../interfaces/resource.interfaces";
import YearSelect from "./controlwrappers/YearSelect";
import IndicatorHandler from "./IndicatorHandler";
import ChartHandler from "./chartHandler.js"

export default class GuiHandler {
  #datahandler!: DataHandler;
  #maphandler!: MapHandler;
  #chartHandler;
  #selectedMunicipality: any = {};
  #selectedCanton: any = {};
  #defaultLocation = "Kriens [Gemeinde - Hektaren]";
  #selectedLocation: any = {};
  #aggregation = "canton-municipality";
  #indicatorHandler: any;
  #yearSelect;
  #accessParameters!: UserResource;

  constructor(datahandler: DataHandler, maphandler: MapHandler) {
    this.#datahandler = datahandler;
    this.#maphandler = maphandler;
    this.#chartHandler = new ChartHandler();
    this.#setAccessParameter().then(() => {
      //then only make new IndicatorHandler
      this.#indicatorHandler = new IndicatorHandler(
        this,
        datahandler,
        maphandler
      );
    });
    this.#yearSelect = new YearSelect();
    this.#setAccessParameter();
    this.#observeYearTextChange();
  }

  async #setAccessParameter() {
    // Wait for the data to be fetched
    const response = await this.#datahandler.requestUserResources();
    this.#accessParameters = response.data;

    //----------------------------------------------

    // new structure has to be defined in the backend and then updated in the frontend
    // this.#accessParameters.additionalFeatures.reachability.access = true;
    //this.#accessParameters.additionalFeatures.economicStructure.access = true;

    //----------------------------------------------

    console.log("Access parameters are set:", this.#accessParameters);
    this.#setDefaults();
  }

  #setDefaults() {
    const defaultLocationObject =
      this.#accessParameters.default.location || this.#defaultLocation;
    this.#defaultLocation = defaultLocationObject;
    this.#initControls();
  }

  getAccessParameter() {
    return this.#accessParameters;
  }

  async #initControls() {
    var that = this;
    $("#guighost").data("obj", this);

    // if accessEconomicStructure true -> show button
    if (this.#accessParameters.additionalFeatures.economicStructure?.access) {
      console.log('Access to economic structure is granted');
      $("#economicButton").html('<label class="economic-title" id="economic-title" style="opacity:1">Wirtschaft</label>');
      const economicTitleElement: HTMLElement | null = document.getElementById("economic-title")
      economicTitleElement.addEventListener("click", () => {
        this.economicAnalysis();

      })

      // const name:string = <string>"zach" as string

    }

    const allowedLocations = this.#accessParameters.locations.map(
      (loc) => loc.name
    );

    const locations = await this.#datahandler.requestAllLocations();

    $("#p_location")
      // @ts-ignore
      .autocomplete({
        source: function (request: any, response: any) {
          const filteredLocations = Object.keys(locations)
            // Filter locations that are not allowed based on the access parameters
            .filter((loc) => allowedLocations.includes(loc));
          // @ts-ignore
          response($.ui.autocomplete.filter(filteredLocations, request.term));
        },
        minLength: 3,
        select: async (event: any, ui: any) => {
          var selectedLocation = locations[ui.item.value];
          this.#aggregation = selectedLocation.properties.aggregate;
          that.#selectedLocation = selectedLocation;

          that.#maphandler.visualizeBoundaries(
            selectedLocation,
            "Municipality"
          );
          that.#maphandler.zoomToBoundingbox(
            selectedLocation.properties.boundingbox
          );
          that.#indicatorHandler.processIndicators();

          const data = await this.#datahandler.requestHHandPeople({
            p_aggregation: selectedLocation.properties.aggregate,
            p_canton: selectedLocation.properties.id,
            p_municipality: selectedLocation.properties.id,
            p_year: $("#year-until").text() || $("#year-from").text(),
          });
          this.#maphandler.setFeatureCollectionHHAndPeople(data);
        },
      })
      .css("width", "250px")
      // This is the part of loading the map at the default location. It takes very long here. - check this out
      .autocomplete("search", that.#defaultLocation);

    // @ts-ignore
    var menu = $("#p_location").autocomplete("widget");
    $(menu[0].children[0]).click();
    this.fadeIn();
  }

  economicAnalysis() {
    // button Wirtschaftsstruktur Analyse clicked
    var that = this;
    console.log('Selected Location:', that.#selectedLocation.properties.name);

    let selectedLocationName = that.#selectedLocation.properties.name;

    if (that.#aggregation === 'municipality-quarter' || that.#aggregation === 'municipality-square') {
      console.log('Economic Analysis - Municipality:', that.#selectedLocation.properties.id);
      // Show loading indicator
      document.getElementById('loadingIndicator').style.display = 'block';

      // Create Promises for both data requests
      const sectionPromise = new Promise((resolve, reject) => {
        this.#datahandler.requestEconomicStructureBySection({
          p_municipality: that.#selectedLocation.properties.id,
        }, (data) => {
          console.log(data);
          resolve(data);
        });
      });

      const yearPromise = new Promise((resolve, reject) => {
        this.#datahandler.requestEconomicStructureByYear({
          p_municipality: that.#selectedLocation.properties.id,
        }, (data) => {
          console.log(data);
          resolve(data);
        });
      });

      // Wait for both Promises to resolve
      Promise.all([sectionPromise, yearPromise])
        .then(([dataBySection, dataByYear]) => {
          //that.#chartHandler.createCharts(dataBySection, dataByYear, selectedLocationName);
          localStorage.setItem('dataBySection', JSON.stringify(dataBySection));
          localStorage.setItem('dataByYear', JSON.stringify(dataByYear));
          localStorage.setItem('selectedLocationName', selectedLocationName);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          document.getElementById('loadingIndicator').style.display = 'none';
          window.open('ecoHTML.html', '_blank');
        });

    } else if (that.#aggregation === 'canton-municipality' || that.#aggregation === 'canton-district') {
      console.log('Economic Analysis - Canton:', that.#selectedLocation.properties.id);
      // Show loading indicator
      document.getElementById('loadingIndicator').style.display = 'block';

      // Create Promises for both data requests
      const sectionPromise = new Promise((resolve, reject) => {
        this.#datahandler.requestEconomicStructureBySectionCanton({
          p_canton: that.#selectedLocation.properties.id,
        }, (data) => {
          console.log(data);
          resolve(data);
        });
      });

      const yearPromise = new Promise((resolve, reject) => {
        this.#datahandler.requestEconomicStructureByYearCanton({
          p_canton: that.#selectedLocation.properties.id,
        }, (data) => {
          console.log(data);
          resolve(data);
        });
      });

      // Wait for both Promises to resolve
      Promise.all([sectionPromise, yearPromise])
        .then(([dataBySection, dataByYear]) => {
          //that.#chartHandler.createCharts(dataBySection, dataByYear, selectedLocationName);
          localStorage.setItem('dataBySection', JSON.stringify(dataBySection));
          localStorage.setItem('dataByYear', JSON.stringify(dataByYear));
          localStorage.setItem('selectedLocationName', selectedLocationName);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          document.getElementById('loadingIndicator').style.display = 'none';
          window.open('ecoHTML.html', '_blank');
        });
    }
  }



  getSelectedMunicipalityID() {
    if (this.#selectedMunicipality && this.#selectedMunicipality.properties)
      return this.#selectedMunicipality.properties.id;
    return "1059"; //Kriens
  }

  getSelectedCantonID() {
    if (this.#selectedCanton && this.#selectedCanton.properties)
      return this.#selectedCanton.properties.id;
    return "3"; //Luzern
  }

  getSelectedLocationID() {
    if (this.#selectedLocation && this.#selectedLocation.properties)
      return this.#selectedLocation.properties.id;
    return "3"; //Luzern
  }

  getAggregation() {
    return this.#aggregation;
  }

  fadeIn() {
    $("#img").remove();
    $("#map").css("opacity", 1);
    $(
      "#indicatorWrapper, #indicatorParametersWrapper, #globalParameterWrapper, #isochronePoiWrapper, #bottomRightContent, #year-wrapper"
    ).fadeTo("slow", 1);
  }

  #observeYearTextChange() {
    const targetNode = $("#background-year-wrapper")[0];
    const config = { attributes: true, childList: true, subtree: true };
    const callback = async (mutationsList: any, observer: any) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "attributes") {
          var yearFrom = $("#year-from").text().trim();
          var yearUntil = $("#year-until").text().trim();
          var that = this;
          this.#indicatorHandler.updateIndicatorSelection(yearFrom, yearUntil);

          if ($("#indicatorWrapper .customSelectedOption").length > 0) {
            if (yearFrom && !yearUntil) {
              this.#maphandler.visualizeBoundaries(
                this.#selectedMunicipality,
                "Municipality"
              );
              this.#indicatorHandler.processIndicators();
              const hhAndPeople = await that.#datahandler.requestHHandPeople({
                p_aggregation: this.getAggregation(),
                p_canton: this.#selectedLocation.properties.id,
                p_municipality: this.#selectedLocation.properties.id,
                p_year: yearFrom,
              });
              this.#maphandler.setFeatureCollectionHHAndPeople(hhAndPeople);
            } else if (yearFrom && yearUntil) {
              this.#maphandler.visualizeBoundaries(
                this.#selectedMunicipality,
                "Municipality"
              );
              this.#indicatorHandler.processIndicators();

              const hhAndPeople = await this.#datahandler.requestHHandPeople({
                p_aggregation: this.getAggregation(),
                p_canton: that.#selectedLocation.properties.id,
                p_municipality: that.#selectedLocation.properties.id,
                p_year: yearUntil,
              });

              this.#maphandler.setFeatureCollectionHHAndPeople(hhAndPeople);
            }
          }
        }
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }
}
